import React from 'react'

import user from '../../../assets/user.svg'
import order from '../../../assets/order.svg'
import worker from '../../../assets/worker.svg'
import admin from '../../../assets/work.svg'
import apply from '../../../assets/apply.svg'

export default function Dash() {
  return (
    <div>
        <div className="col-lg-8  m-3 p-3 d-flex flex-wrap  bg-white mx-auto">
            <a href='/my.user' className="border p-2 user_item m-1 rounded text-3xl flex-col">
              <img
                src={user}
                alt="icon user"
                className="bg-gray-50 p-3 w-24 h-24 rounded-full mx-auto"
              />
              <h2 className='text-xl font-bold text-center'>Utilisateurs</h2>
              <p className='text-xs text-center'>Vous pouvez voir et modifier nos utilisateurs </p>
            </a>
            <a href='my.service' className="border p-2 user_item m-1 rounded text-3xl flex-col">
              <img
                src={order}
                alt="icon user"
                className="bg-gray-50 p-3 w-24 h-24 rounded-full mx-auto"
              />
              <h2 className='text-xl font-bold text-center'>Commandes</h2>
              <p className='text-xs text-center'>Vous pouvez voir et modifier les services des demandes par des utilisateurs </p>
            </a>
            <a href='/my.friend' className="border p-2 user_item m-1 rounded text-3xl flex-col">
              <img
                src={worker}
                alt="icon user"
                className="bg-gray-50 p-3 w-24 h-24 rounded-full mx-auto"
              />
              <h2 className='text-xl font-bold text-center'>Partenaires</h2>
              <p className='text-xs text-center'>Vous pouvez voir et modifier nos techniciens ici. </p>
            </a>
            <a href='/my.useradmin' className="border p-2 user_item m-1 rounded text-3xl flex-col">
              <img
                src={admin}
                alt="icon user"
                className="bg-gray-50 p-3 w-24 h-24 rounded-full mx-auto"
              />
              <h2 className='text-xl font-bold text-center'>Administrateur</h2>
              <p className='text-xs text-center'>Vous pouvez voir et modifier nos collaborateurs ici. </p>
            </a>
            <a href='/my.application' className="border p-2 user_item m-1 rounded text-3xl flex-col">
              <img
                src={apply}
                alt="icon user"
                className="bg-gray-50 p-3 w-24 h-24 rounded-full mx-auto"
              />
              <h2 className='text-xl font-bold text-center'>Candidatures</h2>
              <p className='text-xs text-center'>Vous pouvez gerer les personnes qui souhaitent travailler avec nous ici. </p>
            </a>
          </div>
    </div>
  )
}
